export default __webpack_public_path__ + "static/media/AIOT_banner_m.9193a373.png";